import { Action, Subject } from "./types";

/**
 * The ONE permission that gates the 849 review surface (spec #7634, #7656).
 *
 * The review page (queue, claim panel, parse view, stated decisions, claim
 * aging) and the claim record page's corrections (re-point, undo, unlink) all
 * change records or exist only to lead to a change, so a person who can open
 * them can apply what they answer there. Before this, the page was gated on
 * Read while its answers needed Update, so a Read-only reviewer's claim links
 * were refused after they had filled the form in.
 *
 * Shared by the frontend route guard and every handler gate on the surface, so
 * the two cannot drift. Browse and Labeled — the record — stay on
 * `SD849Response.Read`.
 */
export const SD_849_REVIEW_SURFACE_PERMISSION = {
  action: Action.Update,
  subject: Subject.SD849Response,
} as const;

/**
 * The record permission the surface stands on: Browse, Labeled, the email
 * detail (`getEmailForLabeling`) and the claim record read stay on
 * `SD849Response.Read`, and the review page calls them to open an email.
 */
export const SD_849_RECORD_PERMISSION = {
  action: Action.Read,
  subject: Subject.SD849Response,
} as const;

/**
 * Everything a person needs to work the review surface: the record's Read (the
 * page opens emails and claim records through it) plus the one surface
 * permission. CASL grants no implied actions — Update does not imply Read — so
 * the route guard, `useCanReview` and every handler gate check ALL of these;
 * an Update-only user must not reach a page whose reads 403.
 */
export const SD_849_REVIEW_SURFACE_ACCESS = [
  SD_849_RECORD_PERMISSION,
  SD_849_REVIEW_SURFACE_PERMISSION,
] as const;
